export default {
    S1:{
        'event': 'scroll',
        'scrollType': 'section',
        'scrollSection': 'more ways we\'re tackling housing affordability', // e.g., "more ways we're tackling housing affordability" 
        'siteSection': 'more ways we\'re tackling housing affordability', // e.g., "more ways we're tackling housing affordability"
    },
    S2:{
        'event': 'scroll',
        'scrollType': 'section',
        'scrollSection': 'learn more about our commitment to housing affordability', // e.g., "more ways we're tackling housing affordability" 
        'siteSection': 'learn more about our commitment to housing affordability', // e.g., "more ways we're tackling housing affordability"
    },
    S3:{
        'event': 'scroll',
        'scrollType': 'section',
        'scrollSection': 'additional resources and education', // e.g., "more ways we're tackling housing affordability" 
        'siteSection': 'additional resources and education', // e.g., "more ways we're tackling housing affordability"
    },
    S4: {
        'event': 'scroll',
        'scrollType': 'section',
        'scrollSection': 'map', 
        'siteSection': 'map',
    },
    S5: {
        'event': 'scroll',
        'scrollType': 'section',
        'scrollSection': 'we\'re committed to our communities', // e.g., "get insights and perspectives" 
        'siteSection': 'we\'re committed to our communities', // e.g., "get insights and perspectives"
    },
    C1: {
        'event': 'key-interaction',
        'lineOfBusiness': 'ent: interaction',
        'userActionTaken': 'learn more',
        'buttonLocation': 'mid', 
        'siteSection': 'more ways we\'re tackling housing affordability', // e.g., "get insights and perspectives" 
        'clickText': '150 million'
       },
    C2: {
        'event': 'key-interaction',
        'lineOfBusiness': 'ent: interaction',
        'userActionTaken': 'learn more',
        'buttonLocation': 'mid', 
        'siteSection': 'learn more about our commitment to housing affordability', // e.g., "get insights and perspectives" 
        'clickText': '{{lower case subtitle}}'  //  e.g., "making homeownership accessible to all americans"
       },
    C3: {
        'event': 'key-interaction',
        'lineOfBusiness': 'ent: interaction',
        'userActionTaken': 'learn more',
        'buttonLocation': 'mid', 
        'siteSection': 'additional resources and education', 
        'clickText': '{{lower case item title}}'  //  e.g., "low-to-moderate-income home loans"
    },
    C4: 
        {
            'event': 'key-interaction',
            'lineOfBusiness': 'ent: interaction',
            'userActionTaken': 'map interaction',
            'buttonLocation': 'mid', 
            'siteSection': 'map',
            'clickText': 'see the map'
    }, 
    C5: {
            'event': 'key-interaction',
            'lineOfBusiness': 'ent: interaction',
            'userActionTaken': 'learn more',
            'buttonLocation': 'mid', 
            'siteSection': 'we\'re committed to our communities',
            'clickText': 'learn more about the other ways we’re stepping up in our local neighborhoods' 
    }
}